/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Isnoshow2Inputs */

const en__field_isnoshow2 = /** @type {(inputs: _Field_Isnoshow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No-Show`)
};

const de__field_isnoshow2 = /** @type {(inputs: _Field_Isnoshow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No-Show`)
};

/**
* | output |
* | --- |
* | "No-Show" |
*
* @param {_Field_Isnoshow2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_isnoshow2 = /** @type {((inputs?: _Field_Isnoshow2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Isnoshow2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_isnoshow2(inputs)
	return de__field_isnoshow2(inputs)
});
export { _field_isnoshow2 as "_field_isNoShow" }